import React from "react";
import configureicon from '../../src/asset/configurebuttonicon.svg'

const ConfigureButton = ({ onClick }) => {
  return (
    <button
      className="py-4 px-8 font-bold uppercase tracking-wider flex items-center justify-center w-full"
      style={{
        background: "linear-gradient(112.38deg, rgba(255, 255, 255, 0.5) -120.84%, rgba(255, 255, 255, 0.1) 79.67%)",
        color: "#DAAA00",
        fontFamily: "Montserrat, sans-serif",
        fontSize: "14px",
        fontWeight: 700,
        lineHeight: "19.6px",
        textAlign: "center",
        border: "none",
        cursor: "pointer",
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClick}
    >
      {/* Inner div for precise layout control */}
      <div className="flex items-center justify-center gap-2">
        <span>Configure Now</span>
        <img
          src={configureicon}
          alt="Chevron"
          className="w-3 h-3 ml-1 inline-block"
        />
      </div>
    </button>
  );
};

export default ConfigureButton;
